import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { HttpParams } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, HostListener, OnDestroy, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep, find, filter, findIndex } from 'lodash-es';
import { MessageService } from 'primeng/api';
import { ReferenceUtilService } from '../reference-tree-view/reference-util.service';
import { ActionType, ModelType, UiActions } from '../reference-tree-view/reference.enum';
import { Subject, Subscription, combineLatest, takeUntil } from 'rxjs';
import { getRoles } from 'src/app/STORE/actions/roles.actions';
import {
  deleteTableAcl,
  deletedAcl,
  getTableAcl,
  newAclCreated,
  newlyCreatedAclBatch,
  saveBatchTableAcl,
  saveTableAcl,
  updateAclBatch,
  updateTableAclRecords
} from 'src/app/STORE/actions/tableacl.actions';
import { getAllQueries } from 'src/app/STORE/actions/queryBuilder.actions';
import { allQueries } from 'src/app/STORE/selectors/queryBuilder.selector';
import { rolesTable } from 'src/app/STORE/selectors/roles.selector';
import {
  deletedAclRecord,
  newlyCreatedAcl,
  newlyCreatedaclDataBatch,
  saveLoader,
  tableAclRecords,
  updatedRecordsAfterPaste
} from 'src/app/STORE/selectors/tableacl.selector';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { RegexPatternConstants } from 'src/app/base/regex-pattern.constants';
import { ReferenceTreeViewComponent } from '../reference-tree-view/reference-tree-view.component';
import { VsQueryBuilderService } from '../vs-qb-builder/vs-query-builder.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { UtilService } from 'src/app/services/util.service';
import { error } from 'console';

@Component({
  selector: 'vb-table-acl',
  templateUrl: './table-acl.component.html',
  styleUrls: ['./table-acl.component.scss'],
  standalone: false //NOSONAR
})
export class TableAclComponent implements OnInit, OnChanges, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private store = inject(Store);
  private qbService = inject(VsQueryBuilderService);
  private translate = inject(TranslateService);
  private appGlobalService = inject(AppGlobalService);
  private util = inject(UtilService);
  private referenceUtil = inject(ReferenceUtilService);
  private messageService = inject(MessageService);

  @Input() formData: any = null;
  @Input() tableIdMap: any = null;
  @Input() disableField = false;
  rolesData: any;
  tableAclFormRolesData: any = [];
  aclForm: FormGroup;
  showTableAcl = false;
  tableAclFormData: any;
  submitted = false;
  appAdminSid: string;
  dataFromBE: any;
  subscriptions: Subscription[] = [];

  showQueryBuilder = false;
  conditionProperty: any;
  aclLoader = false;
  curDropOpt = { sid: '', operation: '', prevOption: '', prevConditionId: '' };
  aclOptions: any = [];
  conditional: any;
  appUserTableId: any;
  curTableId: any;
  curTableType: any;
  currentTableName: any = null;
  destroy$: Subject<boolean> = new Subject<boolean>();
  appId = '';
  orgId = '';
  queriesMap = {};
  addTableAcl = false;
  message: string;
  messages: any = {};
  errorFlag: boolean;
  buttonName = '';
  columnRolesToCopy: any;
  rowRolesToCopy: any;
  editPasteColumn = false;
  editPasteRow = false;
  columnItems: any = [];
  rowItems: any = [];
  apiDatastart: 0;
  apiDataLenght: 100;
  isLoading: boolean;
  currentAcl: any = null;
  currentAclSid: any = null;
  showLoader = false;
  isDeactivateRecords = false;
  permissionActions = [
    { value: 'ALWAYS', label: 'Always' },
    { value: 'NEVER', label: 'Never' },
    { value: 'CONDITIONAL', label: 'Conditional' }
  ];
  actionOnOptions = [
    { value: 'ACTIVE_RECORDS', label: 'Active Records' },
    { value: 'INACTIVE_RECORDS', label: 'InActive Records' },
    { value: 'BOTH', label: 'Both' }
  ];
  actionType = [
    { value: 'CREATE_ACL', label: 'Create' },
    { value: 'READ_ACL', label: 'Read' },
    { value: 'UPDATE_ACL', label: 'Update' },
    { value: 'DELETE_ACL', label: 'Delete' }
  ];

  optionsForAcl = [
    { value: 'ALWAYS', label: 'Always' },
    { value: 'NEVER', label: 'Never' },
    { value: 'CONDITIONAL', label: 'Conditional' }
    // { value: 'SAME_AS_CREATE', label: 'Same as Create' },
    // { value: 'SAME_AS_READ', label: 'Same as Read' },
    // { value: 'SAME_AS_UPDATE', label: 'Same as Update' },
    // { value: 'SAME_AS_DELETE', label: 'Same as Delete' },
  ];
  successFlag = false;
  currentActionName: any;

  get isBetaAccessPrivilegeConsumable(): boolean {
    return this.appGlobalService.betaAccessPrivilegeForApp;
  }

  openTableAcl() {
    this.showTableAcl = true;
    this.aclLoader = true;
    this.tableAclFormData = [];
    this.store.dispatch(
      getTableAcl({
        apiConstants: ApiConstants.getTableAclBySid,
        tableid: { tableid: this.formData.sid }
      })
    );
    this.store.dispatch(
      getRoles({
        apiConstants: ApiConstants.getRolesData,
        filter: {
          start: 0,
          length: 100
        }
      })
    );
    this.setTableAclData();
  }

  cancelQb(value) {
    const updatedAcl = this.setDataInTableAclForm(this.currentAcl);
    this.tableAclFormData = this.tableAclFormData.map((obj) =>
      obj.sid === updatedAcl.sid ? { ...obj, ...updatedAcl } : obj
    );
    this.tableAclFormData = [...this.tableAclFormData];
  }

  setTableAclData() {
    const aclRes = this.store.select(tableAclRecords);
    const rolesRes = this.store.select(rolesTable);
    const d = combineLatest(rolesRes, aclRes).subscribe((data) => {
      if (data[0].totalRecords === 0) {
        this.aclLoader = false;
        this.tableAclFormData = null;
      } else if (data[0].totalRecords > 0 && data[0].totalRecords !== undefined && data[1].length > 0) {
        const roles = cloneDeep(data[0].rolesTable);
        this.rolesData = roles;
        this.tableAclFormRolesData = [];
        const appAdminObject: any = find(this.rolesData, { shortName: 'App Admin' });
        if (appAdminObject !== undefined) {
          this.tableAclFormRolesData.push(appAdminObject);
          this.appAdminSid = appAdminObject.sid;
        }
        this.rolesData?.forEach((role) => {
          const indexOfField = this.tableAclFormRolesData.findIndex((dt: any) => dt.shortName === role.shortName);
          if (!(indexOfField > -1)) {
            this.tableAclFormRolesData.push(role);
          }
        });
        const tableData: any = [];
        this.dataFromBE = data[1];
        const defautlvalues = filter(this.dataFromBE, { aclFieldType: 'DEFAULT' });
        let defaultActions = ['CREATE', 'READ', 'UPDATE', 'DELETE'];

        const addRecordsToTable = (records) => {
          records.forEach((row) => {
            if (row) {
              tableData.push(this.setDataInTableAclForm(row));
            }
          });
        };

        const getActionRecords = (applicableFor, actions = defaultActions) => {
          return actions.map((action) => find(defautlvalues, { actionName: action, applicable_for: applicableFor }));
        };

        if (
          this.isDeactivateRecords &&
          this.curTableType !== 'query_view'
        ) {
          const activeRecords = getActionRecords('ACTIVE_RECORDS', [
            'CREATE',
            'READ',
            'UPDATE',
            'DELETE',
            'DEACTIVATE',
          ]);
          addRecordsToTable(activeRecords);

          const activeCustomValues = filter(this.dataFromBE, {
            aclFieldType: 'CUSTOM',
            applicable_for: 'ACTIVE_RECORDS'
          });
          addRecordsToTable(activeCustomValues);

          const inActiveRecords = getActionRecords('INACTIVE_RECORDS', [
            'CREATE',
            'READ',
            'UPDATE',
            'DELETE',
            'ACTIVATE',
          ]);
          addRecordsToTable(inActiveRecords);

          const inActiveCustomValues = filter(this.dataFromBE, {
            aclFieldType: 'CUSTOM',
            applicable_for: 'INACTIVE_RECORDS'
          });
          addRecordsToTable(inActiveCustomValues);
        } else {
          if (this.isDeactivateRecords && this.curTableType === 'query_view') {
            defaultActions = ['CREATE', 'READ', 'UPDATE', 'DELETE', 'ACTIVATE_QVIEW', 'DEACTIVATE_QVIEW'];
          }

          const defaultRows = defaultActions.map((action) => find(defautlvalues, { actionName: action }));
          addRecordsToTable(defaultRows);

          const customValues = filter(this.dataFromBE, { aclFieldType: 'CUSTOM' });
          addRecordsToTable(customValues);
        }
        this.tableAclFormData = tableData;
        this.aclLoader = false;
        d.unsubscribe();
      }
    });
  }

  setDataInTableAclForm(row: any) {
    let enableActions = false;
    if (row.aclFieldType === 'CUSTOM') {
      enableActions = true;
    }
    const rolePermissions = this.tableAclFormRolesData.map((role) => {
      let permissionLabel;
      let querySid;
      if (row.rolesPermissions === undefined) {
        permissionLabel = 'NEVER';
        return {
          label: permissionLabel,
          sid: role.sid,
          querySid: null,
          value: { label: this.translate.instant(permissionLabel), value: role.sid }
        };
      }

      if (role.sid in row.rolesPermissions) {
        querySid = null;
        if (this.optionsForAcl.some((option) => option.value === row.rolesPermissions[role.sid])) {
          permissionLabel = row.rolesPermissions[role.sid];
          if (permissionLabel === 'CONDITIONAL') {
            if (row.rolesConditionId) {
              querySid = row.rolesConditionId[role.sid] || null;
            }
          }
        }
      } else {
        permissionLabel = 'NEVER';
      }
      const translatedLabel = this.translate.instant(permissionLabel);
      return {
        label: permissionLabel,
        sid: role.sid,
        querySid: querySid,
        value: { label: translatedLabel, value: role.sid }
      };
    });
    return {
      sid: row.sid,
      actionName: this.getActionTypeLabel(row.actionName),
      description: row.description,
      aclActionType: this.getActionTypeLabel(row.aclActionType),
      rolesPermissions: rolePermissions,
      enableActions: enableActions,
      applicableFor: row.applicable_for !== undefined ? row.applicable_for : null
    };
  }

  //getting label for Action name and Action type, when actionname is from default actions, then set the label otherwise display as it is.
  getActionTypeLabel(actionTypeOrName: string): string {
    let type = '';
    switch (actionTypeOrName) {
      case 'CREATE':
        type = 'CREATE_ACL';
        break;
      case 'UPDATE':
        type = 'UPDATE_ACL';
        break;
      case 'DELETE':
        type = 'DELETE_ACL';
        break;
      case 'READ':
        type = 'READ_ACL';
        break;
      case 'CHANGELOG':
        type = 'CHANGELOG_ACL';
        break;
      default:
        type = actionTypeOrName;
        break;
    }
    return type;
  }

  initializeForm() {
    this.aclForm = new FormGroup({
      sid: new FormControl(''),
      actionName: new FormControl('', [
        Validators.required,
        Validators.pattern(RegexPatternConstants.alphanumericName)
      ]),
      description: new FormControl(''),
      aclActionType: new FormControl('', [Validators.required])
    });
    if (this.isDeactivateRecords) {
      this.aclForm.addControl('applicableFor', new FormControl('', [Validators.required]));
    }
  }

  validateActionName(inputName: any) {
    const control: any = this.aclForm.get(inputName);
    let val = false;
    if (control.touched && control.errors) {
      if (control.errors.required && control.value === null) {
        this.messages.actionName = 'Action Name is required';
        val = true;
      } else if (control.errors.pattern) {
        this.messages.actionName = this.translate.instant('ACTION_NAME_PATTERN_EXCEPTION');
        val = true;
      }
    } else if (control.untouched && control.errors) {
      if (control.errors.pattern) {
        this.messages.actionName = this.translate.instant('ACTION_NAME_PATTERN_EXCEPTION');
        val = true;
      }
    } else {
      this.messages.actionName = '';
      val = false;
    }
    return val;
  }

  validateActionType(inputName: any) {
    const control: any = this.aclForm.get(inputName);
    let val = false;
    if (control.touched && !control.value && this.submitted) {
      this.messages.aclActionType = 'Action Type is a required field';
      val = true;
    } else {
      this.messages.aclActionType = '';
      val = false;
    }
    return val;
  }

  updateAclAction(aclData) {
    aclData = { ...this.currentAcl, ...aclData };
    const saveapiConstants = ApiConstants.updateTableAcl;
    this.store.dispatch(
      saveTableAcl({
        saveapiConstants,
        aclData
      })
    );
    this.setNewlyCreatedOrUpdatedData('UPDATE');
  }

  getAclActionType(type) {
    let val = type;
    switch (type) {
      case 'CREATE_ACL':
        val = 'CREATE';
        break;
      case 'UPDATE_ACL':
        val = 'UPDATE';
        break;
      case 'DELETE_ACL':
        val = 'DELETE';
        break;
      case 'READ_ACL':
        val = 'READ';
        break;
    }
    return val;
  }

  onUpdate(button: string) {
    this.submitted = true;
    this.clearMessages();
    this.aclForm.markAllAsTouched();

    if (!this.validateForm()) {
      return;
    }

    if (this.aclForm.valid && !this.aclForm.pristine) {
      const aclData = this.prepareAclData();

      if (button === 'CREATE') {
        this.handleCreateAcl(aclData);
      } else if (button === 'UPDATE') {
        this.handleUpdateAcl(aclData);
      }

      this.resetFormState();
    }
  }

  clearMessages() {
    this.message = '';
    this.messages = {};
    this.errorFlag = false;
  }

  validateForm(): boolean {
    const actionName: any = this.aclForm.get('actionName');
    const applicableFor = this.aclForm.get('applicableFor');
    const aclActionType: any = this.aclForm.get('aclActionType');

    if (!actionName.value) {
      this.messages.actionName = this.translate.instant('ACTION_NAME_REQUIRED');
    } else if (!actionName.valid) {
      this.messages.actionName = actionName.hasError('pattern')
        ? this.translate.instant('ACTION_NAME_PATTERN_EXCEPTION')
        : this.translate.instant('ACTION_NAME_INVALID');
      return false;
    }

    if (applicableFor !== null) {
      if (!applicableFor.value) {
        this.messages.applicableFor = this.translate.instant('ACTIVE_ON_REQUIRED');
      }
    }

    if (!aclActionType.value) {
      this.messages.aclActionType = this.translate.instant('ACTION_TYPE_REQUIRED');
    }

    return true;
  }

  prepareAclData(): any {
    return {
      actionName: this.aclForm.get('actionName')?.value,
      description: this.aclForm.get('description')?.value,
      aclActionType: this.getAclActionType(this.aclForm.get('aclActionType')?.value),
      aclFieldType: 'CUSTOM',
      orgId: this.orgId,
      appId: this.appId,
      tableId: this.curTableId
    };
  }

  handleCreateAcl(aclData: any) {
    if (this.isDeactivateRecords) {
      this.createBatchAcl(aclData);
    } else {
      this.createSingleAcl(aclData);
    }
  }

  createSingleAcl(aclData: any) {
    aclData.rolesPermissions = { [this.appAdminSid]: 'ALWAYS' };
    if (this.isDeactivateRecords) {
      aclData.applicable_for = this.aclForm.get('applicableFor')?.value;
    }

    const saveapiConstants = ApiConstants.saveBatchTableAcl;
    const data = { ...aclData };
    this.store.dispatch(saveBatchTableAcl({ saveapiConstants, aclData: [data] }));
    this.setNewlyCreatedTableAclBatchData();
  }

  createBatchAcl(aclData: any) {
    let aclBatchData: any = [];
    const applicableForData = this.aclForm.get('applicableFor')?.value;

    if (applicableForData === 'BOTH') {
      aclData.rolesPermissions = { [this.appAdminSid]: 'ALWAYS' };

      aclBatchData = [
        { ...aclData, applicable_for: 'ACTIVE_RECORDS' },
        { ...aclData, applicable_for: 'INACTIVE_RECORDS' }
      ];

      const saveapiConstants = ApiConstants.saveBatchTableAcl;
      this.store.dispatch(saveBatchTableAcl({ saveapiConstants, aclData: aclBatchData }));
      this.setNewlyCreatedTableAclBatchData();
    } else {
      this.createSingleAcl(aclData);
    }
  }

  handleUpdateAcl(aclData: any) {
    aclData.sid = this.aclForm.get('sid')?.value;

    if (this.isAclModified(aclData)) {
      this.showReferencesIfAny(aclData);
    } else {
      this.updateAclAction(aclData);
    }
  }

  isAclModified(aclData: any): boolean {
    return this.currentAcl.actionName !== aclData.actionName || this.currentAcl.aclActionType !== aclData.aclActionType;
  }

  showReferencesIfAny(aclData: any) {
    const nodeData = { name: this.currentAcl.actionName, type: ModelType.ACL_CUSTOM_ACTION };
    this.referenceUtil
      .handleWithReferences({
        payload: {
          modelId: this.currentAcl?.sid,
          modelType: ModelType.ACL_CUSTOM_ACTION,
          actionType: ActionType.TABLE_ACL_UPDATE,
          action: UiActions.RENAME
        },
        node: nodeData,
        onConfirm: () => this.updateAclAction(aclData),
        onNoReferences: () => this.updateAclAction(aclData),
        onCancel: () => {
          this.isLoading = false;
          this.aclLoader = false;
          this.showLoader = false;
        },
        onError: () => this.updateAclAction(aclData)
      })
      .catch(() => this.updateAclAction(aclData));
  }

  resetFormState() {
    this.addTableAcl = false;
    this.aclForm.reset();
  }

  setNewlyCreatedOrUpdatedData(button?: string) {
    const newAclCreatedSubscription = this.store.select(newlyCreatedAcl).subscribe((acl: any) => {
      if (!acl?.sid) {
        return;
      }

      const existingAcl = this.findAclBySid(acl.sid);
      const displayAcl = this.setDataInTableAclForm(acl);

      if (button === 'CREATE' && existingAcl.length === 0) {
        this.addNewAcl(acl);
        this.showSuccessMessage(displayAcl.actionName, 'created');
      } else if (button === 'UPDATE' && existingAcl.length > 0 && this.currentAclSid === acl.sid) {
        this.updateExistingAcl(acl);
        this.showSuccessMessage(displayAcl.actionName, 'updated');
      }
    });

    this.store.dispatch(newAclCreated({ createdAcl: null }));
    this.addToSubscriptionsList(newAclCreatedSubscription);
  }

  setNewlyCreatedTableAclBatchData() {
    const newAclCreatedSubscription = this.store.select(newlyCreatedaclDataBatch).subscribe((aclBatch: any[]) => {
      if (!aclBatch || aclBatch.length === 0) {
        return;
      }

      aclBatch.forEach((acl) => {
        const existingAcl = this.findAclBySid(acl.sid);
        const displayAcl = this.setDataInTableAclForm(acl);
        if (existingAcl.length === 0) {
          this.addNewAcl(acl);
          this.showSuccessMessage(displayAcl.actionName, 'created');
        }
      });
    });

    this.store.dispatch(newlyCreatedAclBatch({ newlyCreatedaclDataBatch: null }));
    this.addToSubscriptionsList(newAclCreatedSubscription);
  }

  findAclBySid(sid: string) {
    return filter(this.tableAclFormData, { sid });
  }

  addNewAcl(acl: any) {
    this.tableAclFormData = [...this.tableAclFormData, this.setDataInTableAclForm(acl)];
    if (this.isDeactivateRecords) {
      this.sortAclFormData();
    }
    this.clearCurrentAcl();
  }

  updateExistingAcl(acl: any) {
    const updatedAcl = this.setDataInTableAclForm(acl);
    this.tableAclFormData = this.tableAclFormData.map((obj) =>
      obj.sid === updatedAcl.sid ? { ...obj, ...updatedAcl } : obj
    );
    if (
      this.currentAcl.actionName !== updatedAcl.actionName ||
      this.currentAcl.aclActionType !== updatedAcl.aclActionType
    ) {
      const index = this.tableAclFormData.findIndex(
        (x) => x.actionName === this.currentAcl.actionName && x.sid !== updatedAcl.sid
      );
      if (index > -1) {
        this.tableAclFormData[index] = {
          ...this.tableAclFormData[index],
          actionName: updatedAcl.actionName,
          aclActionType: updatedAcl.aclActionType
        };
      }
    }
    if (this.isDeactivateRecords) {
      this.sortAclFormData();
    }
    this.clearCurrentAcl();
    this.submitted = false;
  }

  sortAclFormData() {
    this.tableAclFormData.sort((a, b) => a.applicableFor.localeCompare(b.applicableFor));
  }

  showSuccessMessage(actionName: string, action: string) {
    const translatedName = this.translate.instant(actionName);
    this.showMessage('success', this.translate.instant('ACTION_SUCCESS_MSG', { actionName: translatedName, action: action }));
  }

  clearCurrentAcl() {
    this.currentAcl = null;
    this.currentAclSid = null;
  }

  editqb(rowIndex, roleIndex) {
    this.showQueryBuilder = true;
    const data = this.tableAclFormData[rowIndex];
    const actionName = data.actionName;
    //operation will be the actionName
    this.curDropOpt.operation = actionName;
    this.currentAcl = find(this.dataFromBE, { sid: data.sid });
    this.currentAclSid = this.currentAcl.sid;
    //sid of the selected queryBuilder role
    const roleSid = this.tableAclFormRolesData[roleIndex].sid;
    this.curDropOpt.sid = roleSid;
    const ind = this.tableAclFormRolesData.findIndex((role) => {
      return role.sid === roleSid;
    });
    const permissionSid = this.tableAclFormData[rowIndex].rolesPermissions.findIndex(
      (permission) => permission.sid === this.curDropOpt.sid
    );
    const roleper = this.tableAclFormData[rowIndex].rolesPermissions[permissionSid];
    if (ind > -1 && roleper.value.label === 'Conditional') {
      this.conditional = roleper.value.label === 'Conditional' ? JSON.stringify({ sid: roleper.querySid }) : null;
    }
    this.conditionProperty = {
      name: 'Conditional',
      lookupTo: 'ACL',
      instance: roleSid + actionName,
      appUserNeeded: true,
      value: this.conditional,
      details: {
        sid: roleSid,
        operation: actionName
      }
    };
  }

  firstTimeClickForRoleCopy = true;
  firstTimeClickForActionCopy = true;

  getcolumnItems(index) {
    if (this.firstTimeClickForRoleCopy) {
      this.columnItems = [
        {
          label: `Copy ${this.tableAclFormRolesData[index].shortName} Permissions`,
          icon: 'pi pi-clone',
          command: () => {
            this.onCopy(index);
            this.firstTimeClickForRoleCopy = false;
          }
        },
        {
          label: `Paste`,
          icon: 'pi pi-clone',
          command: () => {
            this.onPaste(index);
          },
          disabled: !this.editPasteColumn
        }
      ];
    } else {
      this.columnItems = [
        {
          label: `Copy ${this.tableAclFormRolesData[index].shortName} Permissions`,
          icon: 'pi pi-clone',
          command: () => {
            this.onCopy(index);
          }
        },
        {
          label:
            this.columnRolesToCopy !== index
              ? `Paste ${this.tableAclFormRolesData[this.columnRolesToCopy].shortName} Permissions`
              : 'Paste',
          icon: 'pi pi-clone',
          command: () => {
            this.onPaste(index);
          },
          disabled: this.columnRolesToCopy === index ? true : !this.editPasteColumn
        }
      ];
    }
  }

  getRowItems(sid) {
    const data = find(this.tableAclFormData, { sid: sid });
    const actionName = this.translate.instant(data.actionName);
    if (this.firstTimeClickForActionCopy) {
      this.rowItems = [
        {
          label: `Copy "${actionName}" Permissions`,
          icon: 'pi pi-clone',
          command: () => {
            this.onRowCopy(sid);
            this.firstTimeClickForActionCopy = false;
          }
        },
        {
          label: `Paste`,
          icon: 'pi pi-clone',
          command: () => {
            this.onRowPaste(sid);
          },
          disabled: !this.editPasteRow
        }
      ];
    } else {
      const copiedData = find(this.tableAclFormData, { sid: this.rowRolesToCopy });
      this.rowItems = [
        {
          label: `Copy "${actionName}" Permissions`,
          icon: 'pi pi-clone',
          command: () => {
            this.onRowCopy(sid);
          }
        },
        {
          label: `Paste "${this.translate.instant(copiedData.actionName)}" Permissions`,
          icon: 'pi pi-clone',
          command: () => {
            this.onRowPaste(sid);
          },
          disabled: !this.editPasteRow
        }
      ];
    }
    if (data && data.enableActions && !this.disableField) {
      this.rowItems.push(
        { separator: true },
        {
          label: this.translate.instant('WHERE_USED'),
          icon: 'pi',
          styleClass: 'menu-item-where-used',
          command: () => this.showWhereUsed(data)
        },
        {
          label: 'Edit',
          icon: 'pi pi-pencil',
          command: () => this.showForm('UPDATE', data)
        },
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => this.deleteAcl(data)
        }
      );
    }
  }

  showPopupLabel(buttonName) {
    return buttonName === 'CREATE' ? 'CREATE_AN_ACTION' : `UPDATE_AN_ACTION`;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscButtonClick(event: KeyboardEvent) {
    this.closeDialog();
  }

  closeDialog() {
    this.tableAclFormData = [];
    this.tableAclFormRolesData = [];
    this.dataFromBE = [];
    this.showTableAcl = false;
    this.showQueryBuilder = false;
    this.conditional = null;
    this.firstTimeClickForActionCopy = true;
    this.firstTimeClickForRoleCopy = true;
    this.store.dispatch(updateTableAclRecords({ tableAclRecords: [] }));
    this.store.dispatch(newAclCreated({ createdAcl: null }));
  }

  showForm(state: string, formData?: any) {
    this.message = '';
    this.messages = {};
    this.errorFlag = false;
    this.initializeForm();
    this.buttonName = state;
    if (formData) {
      this.currentAcl = find(this.dataFromBE, { sid: formData.sid });
      this.currentAclSid = this.currentAcl?.sid;
      if (state === 'UPDATE') {
        this.aclForm.patchValue(formData);
        if (this.isDeactivateRecords && this.currentTableName !== 'Application User') {
          this.aclForm.get('applicableFor')?.disable();
        }
        this.currentActionName = this.aclForm.get('actionName')?.value;
      }
    } else {
      this.currentAcl = null;
      this.currentAclSid = null;
    }
    // Enable all form controls for CREATE mode
    if (state === 'CREATE') {
      this.aclForm.get('actionName')?.enable();
      if (this.isDeactivateRecords && this.currentTableName !== 'Application User') {
        this.aclForm.get('applicableFor')?.enable();
      }
      this.aclForm.get('description')?.enable();
      this.aclForm.get('aclActionType')?.enable();
    }
    // Show dialog after form is fully configured to avoid ExpressionChangedAfterItHasBeenCheckedError
    this.addTableAcl = true;
  }

  addTableACL() {
    // Initialize form and reset state before showing dialog
    this.message = '';
    this.messages = {};
    this.errorFlag = false;
    this.initializeForm();
    this.buttonName = 'CREATE';
    this.currentAcl = null;
    this.currentAclSid = null;
    this.addTableAcl = true;
  }
  closeAddActionDialog() {
    this.addTableAcl = false;
    this.submitted = false;
  }

  confirmDialog(node: any) {
    this.confirmationDialogService.confirm({
      message: 'Are you sure that you want to delete?',
      header: 'Confirmation',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.deleteNode(node);
      },
      reject: () => {
        /* empty */
      }
    });
  }

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }

  deleteNode(node) {
    this.showLoader = true;
    const apiConstants = ApiConstants.deleteTableAcl;
    const ids = { ids: node.sid };
    this.store.dispatch(
      deleteTableAcl({
        apiConstants,
        ids
      })
    );
    this.store.select(deletedAclRecord).subscribe((sid) => {
      const id = filter(this.tableAclFormData, { sid: sid.ids });
      if (sid.ids === this.currentAclSid && id.length === 1) {
        const deletedSid = findIndex(this.tableAclFormData, { sid: sid.ids });
        this.tableAclFormData = [
          ...this.tableAclFormData.slice(0, deletedSid),
          ...this.tableAclFormData.slice(deletedSid + 1)
        ];
        this.showMessage('success', 'Action deleted successfully');
        this.currentAcl = null;
        this.currentAclSid = null;
      }
    });
    this.store.dispatch(deletedAcl({ deletedSid: null }));
  }

  deleteAcl(column: any) {
    this.currentAcl = column;
    this.currentAclSid = this.currentAcl.sid;
    const nodeData = {
      name: column.actionName,
      type: ModelType.ACL_CUSTOM_ACTION
    };
    this.referenceUtil
      .handleWithReferences({
        payload: {
          modelId: column.sid,
          modelType: ModelType.ACL_CUSTOM_ACTION,
          actionType: ActionType.TABLE_ACL_DELETE,
          action: UiActions.DELETE
        },
        node: nodeData,
        onConfirm: () => this.deleteNode(column),
        onNoReferences: () => this.deleteNode(column),
        onCancel: () => {
          this.isLoading = false;
          this.aclLoader = false;
          this.showLoader = false;
        },
        onError: () => this.deleteNode(column)
      })
      .catch(() => this.deleteNode(column))
      .finally(() => (this.showLoader = false));
  }

  showWhereUsed(column: any): void {
    this.showLoader = true;
    this.referenceUtil.showWhereUsed(
      {
        id: column.sid,
        name: column.actionName,
        type: this.translate.instant('ACTION')
      },
      { hideLoader: () => (this.showLoader = false) }
    );
  }

  changeQb(value) {
    if (value) {
      const data = find(this.dataFromBE, { sid: this.currentAclSid });
      if (!data) {
        this.showQueryBuilder = false;
        this.conditional = '';
        return;
      }
      const permissions = { ...data.rolesPermissions, [this.curDropOpt.sid]: 'CONDITIONAL' };
      const roleConditions = { ...data.rolesConditionId, [this.curDropOpt.sid]: value.sid };
      const updatedRowTableData = {
        ...data,
        ...{ rolesPermissions: permissions },
        oldAclValue: this.curDropOpt.prevOption,
        currentRoleSid: this.curDropOpt.sid,
        rolesConditionId: roleConditions
      };
      const saveapiConstants = ApiConstants.updateTableAcl;
      this.store.dispatch(
        saveTableAcl({
          saveapiConstants,
          aclData: updatedRowTableData
        })
      );
      this.setNewlyCreatedOrUpdatedData('UPDATE');
      //this.dataFromBE[rowIndex] = updatedRowTableData;
    } else if (this.currentAcl) {
      const data = this.setDataInTableAclForm(this.currentAcl);
      const updatedData = this.tableAclFormData.map((obj) => {
        return obj.sid === data.sid ? { ...obj, ...data } : obj;
      });
      this.tableAclFormData = [...updatedData];
    }
    this.showQueryBuilder = false;
    this.conditional = '';
  }

  ngOnChanges() {
    this.curTableId = this.formData.sid;
    this.curTableType = this.formData.t_type;
    this.currentTableName = this.tableIdMap[this.curTableId];
    this.qbService.configureQueryBuilder(this.appUserTableId, this.curTableId, this.currentTableName);
  }

  onDropdownChange(event: any, rowIndex: string, roleIndex: string) {
    let updatedRowTableData;
    const rowData = this.tableAclFormData[rowIndex];
    const roleSid = this.tableAclFormRolesData[roleIndex].sid;
    this.curDropOpt.prevOption = rowData.rolesPermissions[roleIndex].label;
    const actionName = this.tableAclFormData[rowIndex].actionName;
    this.currentAcl = find(this.dataFromBE, { sid: rowData.sid });
    this.currentAclSid = this.currentAcl.sid;
    if (rowData.rolesPermissions[roleIndex].label !== rowData.rolesPermissions[roleIndex].value.value) {
      if (event.value === 'CONDITIONAL') {
        this.conditional = '';
        this.showQueryBuilder = true;

        this.curDropOpt.sid = roleSid;

        this.curDropOpt.operation = actionName;
        this.conditionProperty = {
          name: 'Conditional',
          lookupTo: 'ACL',
          instance: roleSid + actionName,
          appUserNeeded: true,
          value: this.conditional,
          details: {
            sid: roleSid,
            operation: actionName
          }
        };
      } else {
        const rowTableData = filter(this.dataFromBE, { sid: rowData.sid });
        if (rowTableData[0] && roleSid) {
          const permissions = { ...rowTableData[0].rolesPermissions, [roleSid]: event.value };
          const roleConditions = { ...rowTableData[0].rolesConditionId };
          let aclConditionId = null;
          if (this.curDropOpt.prevOption === 'CONDITIONAL') {
            aclConditionId = roleConditions[roleSid];
            delete roleConditions[roleSid];
          }
          updatedRowTableData = {
            ...rowTableData[0],
            rolesPermissions: permissions,
            currentRoleSid: roleSid,
            oldAclConditionId: aclConditionId,
            oldAclValue: this.curDropOpt.prevOption,
            rolesConditionId: roleConditions
          };
          this.currentAcl = updatedRowTableData;
          this.currentAclSid = this.currentAcl.sid;
          const saveapiConstants = ApiConstants.updateTableAcl;
          this.store.dispatch(
            saveTableAcl({
              saveapiConstants,
              aclData: updatedRowTableData
            })
          );
          this.setNewlyCreatedOrUpdatedData('UPDATE');
        }
      }
    }
  }

  onDropdownClick(sid) {
    const data = filter(this.dataFromBE, { sid: sid });
    this.aclOptions = [...this.permissionActions];
    // if (data[0].aclFieldType==='CUSTOM') {
    //   let val = `SAME_AS_${data[0].aclActionType}`;
    //   let index = this.aclOptions.findIndex(d => d.value===val);
    //   if (index===-1) {
    //     this.aclOptions.push({ value: val, label: this.translate.instant(val) });
    //   }
    // }
  }

  onActionTypeChange(event, index) {
    const saveapiConstants = ApiConstants.updateTableAcl;
    const data = find(this.dataFromBE, { sid: index });
    this.currentAcl = data;
    this.currentAclSid = this.currentAcl.sid;
    const defaultTypes = ['CONDITIONAL', 'ALWAYS', 'NEVER'];
    if (data) {
      const updatedData = { ...data, aclActionType: event };
      const permissions = updatedData.rolesPermissions;
      // for (const key in updatedData.rolesPermissions) {
      //   if (!defaultTypes.includes(permissions[key])) {
      //     updatedData.rolesPermissions = { ...updatedData.rolesPermissions, [key]: `SAME_AS_${updatedData.aclActionType}` };
      //     //permissions[key] = `SAME_AS_${updatedData.aclActionType}`;
      //   }
      // }
      this.store.dispatch(
        saveTableAcl({
          saveapiConstants,
          aclData: updatedData
        })
      );
      this.setNewlyCreatedOrUpdatedData('UPDATE');
    }
  }

  onCopy(index) {
    this.columnRolesToCopy = index;
    this.editPasteColumn = true;
    this.firstTimeClickForRoleCopy = false;
    this.firstTimeClickForActionCopy = true;
  }

  onRowCopy(index) {
    this.rowRolesToCopy = index;
    this.editPasteRow = true;
    this.firstTimeClickForActionCopy = false;
    this.firstTimeClickForRoleCopy = true;
  }

  onRowPaste(rowIndex) {
    const saveapiConstants = ApiConstants.updateTableAcl;
    const rowToCopy = filter(this.dataFromBE, { sid: this.rowRolesToCopy });
    const rowToPaste = filter(this.dataFromBE, { sid: rowIndex });
    this.currentAcl = rowToPaste[0];
    this.currentAclSid = this.currentAcl.sid;
    if (rowToCopy[0].rolesPermissions !== rowToPaste[0].rolesPermissions) {
      const permissions = rowToCopy[0].rolesPermissions;
      const conditionId = rowToCopy[0].rolesConditionId;
      const updatedRowTableData = { ...rowToPaste[0], rolesPermissions: permissions, rolesConditionId: conditionId };
      this.store.dispatch(
        saveTableAcl({
          saveapiConstants,
          aclData: updatedRowTableData
        })
      );
      this.setNewlyCreatedOrUpdatedData('UPDATE');
    } else {
      this.showMessage('info', this.translate.instant('PERMISSIONS_ARE_SAME'));
    }

  }

  onPaste(columnIndex) {
    const actionIds: any = [];
    let updateRecords = 0;
    const copyRoleSid = this.tableAclFormRolesData[this.columnRolesToCopy].sid;
    const pasteRoleSid = this.tableAclFormRolesData[columnIndex].sid;
    for (let index = 0; index < this.tableAclFormData.length; index++) {
      const cellCopied = this.tableAclFormData[index].rolesPermissions[this.columnRolesToCopy];
      const cellToPaste = this.tableAclFormData[index].rolesPermissions[columnIndex];
      if (
        cellCopied.label !== cellToPaste.label ||
        (cellCopied.label === 'CONDITIONAL' && cellToPaste.label === 'CONDITIONAL')
      ) {
        updateRecords++;
        actionIds.push(this.tableAclFormData[index].sid);
      }
    }
    if (updateRecords > 0) {
      const apiConstants = { ...ApiConstants.cloneColumnLevelPermissions };
      let queryParams = new HttpParams();
      queryParams = queryParams.append('copyRoleSid', copyRoleSid);
      queryParams = queryParams.append('pasteRoleSid', pasteRoleSid);
      const url = `${apiConstants.url}?${queryParams}`;
      const apiObj = { ...apiConstants, ...{ url: url } };
      this.store.dispatch(
        updateAclBatch({
          apiConstants: apiObj,
          actionIds: actionIds
        })
      );
      this.store.select(updatedRecordsAfterPaste).subscribe((records: any) => {
        if (records) {
          records.forEach((row) => {
            const data = this.setDataInTableAclForm(row);
            const updatedData = this.tableAclFormData.map((obj) => {
              return obj.sid === data.sid ? { ...obj, ...data } : obj;
            });
            this.tableAclFormData = [...updatedData];
          });
        }
      });
    } else {
      this.showMessage('info', this.translate.instant('PERMISSIONS_ARE_SAME'));
    }
  }

  onDropdownButtonClick(event, index) {
    console.log(event);
    this.getcolumnItems(index);
  }

  showPopupLabelPermissions() {
    return `Actions and Permissions - `;
  }

  get renderedHeader(): string {
    return `
      <div>
        <span class="static-text">Actions and Permissions - </span>
        <span class="dynamic-text" style="color: blue;">${this.currentTableName}</span>
      </div>
    `;
  }

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  ngOnInit(): void {
    this.appId = this.formData.aid;
    this.orgId = this.formData.orgId;
    this.curTableId = this.formData.sid;
    this.currentTableName = this.tableIdMap[this.curTableId];
    // this.appUserTableId = Object.keys(this.tableIdMap).find((key) => this.tableIdMap[key] === 'Application User');
     this.appUserTableId = this.appGlobalService.get('appTableId');
    if (!this.appUserTableId) {
      this.appUserTableId = Object.keys(this.tableIdMap).find((key) => this.tableIdMap[key] === 'Application User');
    }
    this.store
      .select(saveLoader)
      .pipe(takeUntil(this.destroy$))
      .subscribe((loader: any) => {
        this.showLoader = loader;
      });
    const settings = this.appGlobalService.get('technologySettings');
    this.isDeactivateRecords = settings.deactivateRecords;
    this.store
      .select(tableAclRecords)
      .pipe(takeUntil(this.destroy$))
      .subscribe((updatedRecords: any) => {
        this.dataFromBE = updatedRecords;
      });
    this.qbService.configureQueryBuilder(this.appUserTableId, this.curTableId, this.currentTableName);
    this.initializeForm();
    this.currentAcl = null;
    this.aclOptions = this.optionsForAcl;
    //this.setTableAclData();
    this.store.dispatch(getAllQueries({ apiConstants: ApiConstants.getAllQueriesByAppId }));
    this.store
      .select(allQueries)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res) {
          try {
            this.queriesMap = { ...res };
            console.log(this.queriesMap);
          } catch (e) {
            console.error(e);
          }
        }
      });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    //this.store.dispatch(setTableAcl(null));
    //this.store.dispatch(setRoles(null));
  }
}



